<div class="parent">
  <div class="sort-modal-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mode-dialog-header>
      <h1 heading>Sort</h1>
      <div sub-heading class="sub-header"><span class="sub-header-field">Field:</span>{{ formula.displayName }}</div>
    </mode-dialog-header>
  </div>
  <div class="content-container">
    <!-- Sort types -->
    <mode-labeled-menu
      [label]="'Sort type'"
      [selected]="sortType"
      [menuItems]="sortTypes"
      (menuChange)="onChangeSortType($event)"
    ></mode-labeled-menu>
    <!-- Sort order -->
    <mode-labeled-menu
      *ngIf="!showByManualSort"
      [label]="'Sort order'"
      [selected]="sortOrder"
      [menuItems]="sortOrders"
      (menuChange)="onChangeSortOrder($event)"
    ></mode-labeled-menu>
    <!-- Sort by-field fields -->
    <mode-labeled-field-list-menu
      *ngIf="showByFields"
      [label]="'Field name'"
      [selected]="sortField"
      [fieldsInEncoding]="encodingSortFields"
      [otherFields]="otherSortFields"
      (menuChange)="onChangeField($event)"
    ></mode-labeled-field-list-menu>
    <!-- Sort by-field|nested agg fns -->
    <mode-labeled-menu
      *ngIf="showByFields"
      [label]="'Aggregation'"
      [selected]="sortAggFn"
      [menuItems]="sortAggFns"
      (menuChange)="onChangeAggregation($event)"
    ></mode-labeled-menu>
    <!-- Manual sort list -->
    <mode-sort-modal-list
      *ngIf="showByManualSort"
      [items]="items"
      [formatter]="formatter"
      (orderChanged)="onChangeManualSortOrder($event)"
    ></mode-sort-modal-list>
    <!-- misconfiguration/future support -->
    <div class="info-container" *ngIf="error"><capra-icon icon="icon-info-outline"></capra-icon> {{ error }}</div>
  </div>
  <div mat-dialog-actions>
    <div>
      <capra-button
        text="Reset"
        variant="secondary"
        color="neutral"
        [disabled]="isResetDisabled"
        (clicked)="reset()"
      ></capra-button>
    </div>
    <div>
      <capra-button text="Apply" variant="secondary" color="neutral" (clicked)="apply(false)"></capra-button>
      <capra-button text="Apply and close" color="default" (clicked)="apply(true)"></capra-button>
    </div>
  </div>
</div>
